import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-nautic text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-nautic-gold mb-4">Contact</h3>
            <p className="text-sm">
              Email: <span className="text-nautic-gold">contact@nauticoach.com</span>
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-nautic-gold mb-4">Liens rapides</h3>
            <ul className="text-sm space-y-2">
              <li><a href="/faq" className="hover:text-nautic-gold transition-colors">FAQ</a></li>
              <li><a href="/mentions-legales" className="hover:text-nautic-gold transition-colors">Mentions légales</a></li>
              <li><a href="/politique-confidentialite" className="hover:text-nautic-gold transition-colors">Politique de confidentialité</a></li>
              <li><a href="/cgv" className="hover:text-nautic-gold transition-colors">CGV</a></li>
              <li><a href="/cgu" className="hover:text-nautic-gold transition-colors">CGU</a></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-nautic-light text-center text-sm space-y-1">
          <div>© 2026 NautiCoach. Tous droits réservés.</div>
          <div className="text-xs opacity-80">SIRET : 522 829 282 00048</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;